import { CrossSectionCanvas } from '@pages/cross-section/shared/CrossSectionCanvas';
import { ProjectCodesService } from '@shared/services/ProjectCodesService';
import Konva from 'konva';


function draw(opts: {
    logpoint: any,
    stationStart: number,
    highlighted: boolean,
    csCanvas: CrossSectionCanvas,
    onClickCallback: (logpoint: any, x: number, y: number) => void
}) {
    const { logpoint, csCanvas, stationStart, highlighted, onClickCallback } = opts;
    const canvasOptions = csCanvas.canvasOptions;
    const lowestPoint = csCanvas.lowestPoint;

    const x = canvasOptions.side_margin / 2 + csCanvas.panX + (logpoint.x - stationStart) * canvasOptions.x_scale;
    const y = (csCanvas.height - canvasOptions.bottom_margin) + lowestPoint * canvasOptions.y_scale - logpoint.y * canvasOptions.y_scale + csCanvas.panY;
    const shapes = [];
    let color = null;

    if (x > csCanvas.width - canvasOptions.side_margin / 2 || x < canvasOptions.side_margin / 2) {
        return;
    }

    if (logpoint.tol === 0) {
        color = 'black';
    } else if (logpoint.tol === 1) {
        color = 'red';
    } else if (logpoint.tol === 2) {
        color = 'green';
    } else {
        color = 'gray';
    }

    shapes.push(new Konva.Line({
        name: 'logpoint',
        points: [x, y - 5, x, y + 5],
        stroke: color,
        strokeWidth: 2,
        listening: false
    }));

    shapes.push(new Konva.Line({
        name: 'logpoint',
        points: [x - 5, y, x + 5, y],
        stroke: color,
        strokeWidth: 2,
        listening: false
    }));

    if (logpoint.type === 'TOTAL_STATION') {
        shapes.push(new Konva.Circle({
            name: 'logpoint',
            x: x,
            y: y,
            stroke: color,
            strokeWidth: 1,
            radius: 4,
            listening: false
        }));
    }

    if (logpoint.type === 'VEHICLE') {
        shapes.push(new Konva.Line({
            name: 'logpoint',
            points: [x, y, x + 4, y - 3.5],
            stroke: color,
            strokeWidth: 2,
            listening: false
        }));
    }

    if ($.isNumeric(logpoint.modelDeltaZ) && color !== 'gray') {
        var text = new Konva.Text({
            name: 'logpoint_text',
            x: x,
            y: y + 10,
            text: logpoint.modelDeltaZ.toFixed(2),
            fontSize: 12,
            fontFamily: 'Calibri',
            fill: color
        });
        text.offsetX(text.width() / 2);

        text.on('click tap', () => onClickCallback(logpoint, x, y));
        text.on('mouseover', () => showTooltip(logpoint, x, y, csCanvas));
        text.on('mouseout', csCanvas.clearTooltips);

        shapes.push(text);
    }

    var clickShape = new Konva.Circle({
        name: 'logpoint',
        x: x,
        y: y,
        stroke: 'transparent',
        radius: 10
    });

    if (highlighted) {
        var size = 15;
        var rect = new Konva.Rect({
            x: x - (size - 1) / 2,
            y: y - (size - 1) / 2,
            width: size,
            height: size,
            stroke: 'black',
            strokeWidth: 1,
            listening: false
        });
        shapes.push(rect);
    }

    clickShape.on('click tap', () => onClickCallback(logpoint, x, y));
    clickShape.on('mouseover', () => showTooltip(logpoint, x, y, csCanvas));
    clickShape.on('mouseout', csCanvas.clearTooltips);

    shapes.push(clickShape);
    shapes.forEach(s => csCanvas.contentLayer.add(s));
}


const showTooltip = (logpoint: any, x: number, y: number, csCanvas: CrossSectionCanvas) => {
    var size = 13;
    let t = logpoint.name + '\n';
    if (logpoint.pointName) {
        t += kuura.getMessage('js.cross_section.name') + ': ' + (logpoint.pointName) + '\n';
    }
    if (logpoint.number) {
        t += kuura.getMessage('js.cross_section.number') + ': ' + (logpoint.number) + '\n';
    }
    if (logpoint.code) {
        t += kuura.getMessage('js.cross_section.code') + ': ' + (ProjectCodesService.codeWithDescription(logpoint.code)) + '\n';
    }
    t += kuura.getMessage('js.cross_section.b') + ': ' + (logpoint.x).toFixed(2) + '\n'
        + kuura.getMessage('js.cross_section.z') + ': ' + (logpoint.z).toFixed(2) + '\n'
        + kuura.getMessage('js.cross_section.dz') + ': ' + (logpoint.modelDeltaZ).toFixed(2);

    var rect = new Konva.Rect({
        x: x - (size - 1) / 2,
        y: y - (size - 1) / 2,
        width: size,
        height: size,
        stroke: 'gray',
        strokeWidth: 1,
        listening: false
    });
    var text = new Konva.Text({
        name: 'vertex_hover_text',
        x: x,
        y: y - 8,
        text: t,
        fontSize: 12,
        fontFamily: 'Calibri',
        fill: 'black',
        listening: false
    });
    text.offsetX(text.width() / 2);
    text.offsetY(text.height());

    var boxw = text.width() + 10;
    var boxh = text.height();
    var box = new Konva.Rect({
        x: x - boxw / 2,
        y: y - text.offsetY() - 5 - 5,
        width: boxw,
        height: boxh,
        fill: 'rgba(255,255,255,128)',
        opacity: 0.5,
        listening: false
    });

    csCanvas.tooltipLayer.add(rect);
    csCanvas.tooltipLayer.add(box);
    csCanvas.tooltipLayer.add(text);
    csCanvas.tooltipLayer.draw();
}

const getRgb = (color: string) => 'rgb(' + color + ')'

export const LongSectionLogpoint = {
    draw
}
